module.exports = __webpack_public_path__ + "static/media/portfolio4.184fa5ba.PNG";